import { useEffect } from "react";
import { useNavigate } from "react-router-dom"



const Navigate = ({destination , trigger}) =>{
    const navigate = useNavigate()

    useEffect(() => {
    if (trigger > 0) {
      navigate(destination);
    }
  }, [trigger, destination, navigate]);

    return(
        <></>
    )
}

export default Navigate